"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=e(require("styled-components")).default.li`
    margin: 0;
    padding: 0;
    display: grid;
    grid-row-gap: 13px;

    header {
        h3 {
            margin: 0;
        }
    }

    .values {
        list-style: none;
        margin: 0;
        padding: 0;
        display: grid;
        grid-row-gap: 13px;

        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 24px;
            grid-row-gap: 24px;
        }
    }
`;module.exports=r;
//# sourceMappingURL=styles.js.map
